import { Injectable, inject } from '@angular/core';
import { Query } from '@datorama/akita';
import { CmgCcwPropertyStore } from './ccw-property.store';
import { DirtyChecker2 } from '../../core/dirty-checker-2';
import { CcwPropertyInformationModel } from '../../../closing-cost-worksheet-15/models/ccw-property-information.model';

@Injectable({ providedIn: 'root' })
export class CmgCcwPropertyQuery extends Query<CcwPropertyInformationModel> {
  protected store: CmgCcwPropertyStore;

  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);

  constructor() {
    const store = inject(CmgCcwPropertyStore);

    super(store);

    this.store = store;
  }

  setHead() {
    this.dirtyChecker2.dirtyChecker.setHead();
  }
}
